import React from 'react';
import { Text, useIsMobile, isMobileStyleMixin as isMobile, Icon } from '@amzn/storm-ui';
import { spinner } from '@amzn/storm-ui-icons';
import { useBundle } from '@amzn/react-arb-tools';
import {AccountInfoByType, AccountTypes, DetailAccountInfo, multiCountryAccountType, WeblabedFeatures} from './Types';
import styled, {css} from 'styled-components';
import {AccountListDesktop} from './AccountListDesktop';
import {AccountListMobile} from './AccountListMobile';
import { useAccountContext } from './AccountContextProvider';
import { AccountSelectorMetricsPublisher } from '../metrics';
import {findFeatureLaunchInfo} from "src/components/utils";

const AccountTypeLabel = styled(Text)`
  padding-top: 12px;
  padding-inline-start: 14px;

  ${isMobile(css`
    padding: 8px 0;
  `)}

  && {
    margin-bottom: 0;
  }
`;

type AccountTypeSectionProps = {
  account: AccountInfoByType;
};

export const AccountTypeSection: React.VFC<AccountTypeSectionProps> =
  ({account}) => {
    const {
      setSelectedAccount,
      setSelectedAccountRef,
      setSelectedAccountType,
      hasNestedAccounts,
      numberOfAccountSelection,
      setNumberOfAccountSelection,
      preSelectedAccount
    } = useAccountContext();
    const isMultiCountryAccountType = multiCountryAccountType.includes(account.accountType);
    const accounts = account.accounts;
    const isMobile = useIsMobile();
    const [bundle, isBundleLoading] = useBundle('pages.interstitial');

    if (isBundleLoading) {
      return <Icon type={spinner}></Icon>
    }

    const handleClick = (detailedAccount: DetailAccountInfo, index?: number,
      elementsRef?: React.MutableRefObject<React.RefObject<HTMLElement>[]>) => {
      AccountSelectorMetricsPublisher.publishCounterMonitor('select', 1);
        const shouldShowRegionSelectorList = (detailedAccount.nestedAccounts ? detailedAccount.nestedAccounts.length > 0 : false);
        const shouldShowCountrySelectorList = (hasNestedAccounts && !isMultiCountryAccountType);
        if (shouldShowCountrySelectorList || shouldShowRegionSelectorList){
        setSelectedAccount(detailedAccount);
        setSelectedAccountType(account.accountType);
        setNumberOfAccountSelection(numberOfAccountSelection + 1);
        if (index && elementsRef) {
          setSelectedAccountRef(elementsRef.current[index]);
        }
      } else {
        window.location.href = detailedAccount.url;
      }
    };

    return (
      <>
        {(!preSelectedAccount && account.accountType !== AccountTypes.UNSUPPORTED) &&
          <AccountTypeLabel type="h4" styleAs="h5">{bundle.getMessage(account.accountType as string)}</AccountTypeLabel>}
        {isMobile ? (
          <AccountListMobile accounts={accounts} handleClick={handleClick}/>
        ) : (
          <AccountListDesktop accounts={accounts} accountType={account.accountType} handleClick={handleClick}/>
        )}
      </>
    );
}
